import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AIPotraitPromptComponent } from './prompt-modal/ai-potrait-prompt/ai-potrait-prompt.component';
import { AiPortraitTokenService } from './service/ai-portrait-token.service';
import { AIImageResponse, AIDescriptionResponse, AIBackstoryResponse, AIFullCharacterResponse } from './model/ai-generate-image-response.model';
import { CommonCharacterImageUploadModalComponent } from 'src/app/pages/shared/common-character-image-upload-modal/common-character-image-upload-modal.component';
import { ContentImageUploadModalComponent } from 'src/app/pages/shared/content-image-upload-modal/content-image-upload-modal.component';
import { SubscriptionService } from 'src/app/pages/subscription/services/subscription.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { AiFailureComponent } from '../ai-failure/ai-failure.component';
import { ContentPortraitResponse } from './model/ai-generate-image-response.model';
import { AiTokenRestockComponent } from '../ai-token-restock/ai-token-restock.component';
import { TokenBalanceResponse } from './model/ai-generate-image-response.model';

@Component({
    selector: 'app-ai-generation',
    templateUrl: './ai-generation.component.html',
    styleUrls: ['./ai-generation.component.scss'],
    standalone: false
})
export class AiGenerationComponent implements OnInit {

  playerDetails: any;
  isGenerating: boolean = false;
  isFirst: number | string | any;
  char_id: number | string | any;
  uploadedimage: string | any;
  userId: number | string | any;
  tokenBalance: TokenBalanceResponse | null = null;
  isLoadingBalance: boolean = true;
  modalTitle: string | 'Image' = 'Image';
  tokenCost: number = 0;
  // Optional note from the player, e.g. "make him look older and battle-worn"
  aiInstruction: string = '';
  readonly aiInstructionMaxLength = 400;

  // modalTitle → key in the balance response's ai_costs
  private readonly costKeys: Record<string, string> = {
    Image: 'image',
    Description: 'description',
    Backstory: 'backstory',
    Full: 'full_character',
    Content: 'content_image',
  };





  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private aiPortraitTokenService: AiPortraitTokenService,
    private currentUserService: CurrentUserService,
    private subscriptionService: SubscriptionService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {

    this.getTokenBalance();
  }

  getTokenBalance() {
    this.isLoadingBalance = true;
    this.aiPortraitTokenService.getTokenBalance(this.userId).subscribe({
      next: (res: TokenBalanceResponse) => {
        this.tokenBalance = res;
        // Show what the server will actually charge, not the caller's guess
        const serverCost = res?.ai_costs?.[this.costKeys[this.modalTitle]];
        if (typeof serverCost === 'number') {
          this.tokenCost = serverCost;
        }
        this.isLoadingBalance = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoadingBalance = false;
        this.cdr.detectChanges();
      }
    });
  }

  handleGenerateToken() {
    if (this.tokenBalance?.total - this.tokenCost < 0) {
      this.openTokenRestockModal()
      return;
    }
    this.isGenerating = true;

    // The sheet plus the player's note; the form itself is left untouched
    const characterRequest = { ...this.playerDetails, ai_instruction: this.aiInstruction.trim() };

    if (this.modalTitle === 'Description') {
      this.aiPortraitTokenService.generateDescription(characterRequest).subscribe((res: AIDescriptionResponse) => {
        this.refreshPlanDetails();
        this.isGenerating = false;
        this.activeModal.close(res);
      
          this.cdr.detectChanges();}, (error) => {
        this.isGenerating = false;
        this.activeModal.close();
        this.modalService.open(AiFailureComponent, { size: 'md', centered: true, backdrop: 'static' });
      
          this.cdr.detectChanges();});
    } else if (this.modalTitle === 'Backstory') {
      this.aiPortraitTokenService.generateBackstory(characterRequest).subscribe((res: AIBackstoryResponse) => {
        this.refreshPlanDetails();
        this.isGenerating = false;
        this.activeModal.close(res);
      
          this.cdr.detectChanges();}, (error) => {
        this.isGenerating = false;
        this.activeModal.close();
        this.modalService.open(AiFailureComponent, { size: 'md', centered: true, backdrop: 'static' });
      
          this.cdr.detectChanges();});
    } else if (this.modalTitle === 'Full') {
      this.aiPortraitTokenService.generateFullCharacter(characterRequest).subscribe({
        next: (allRes: AIFullCharacterResponse) => {
          this.refreshPlanDetails();
          this.isGenerating = false;
          // Extract description and backstory to pass along
          const descRes = { character_description: allRes.character_description };
          const backRes = { character_backstory: allRes.character_backstory };

          if (allRes.grok_image_base64) {
            this.openImageUploadModal(allRes.grok_image_base64, descRes, backRes);
          } else {
            this.activeModal.close({
              ...descRes,
              ...backRes
            });
          }
        
          this.cdr.detectChanges();},
        error: (err) => {
          this.isGenerating = false;
          this.activeModal.close();
          this.modalService.open(AiFailureComponent, { size: 'md', centered: true, backdrop: 'static' });
        
          this.cdr.detectChanges();}
      });
    } else if (this.modalTitle === 'Content') {
      this.aiPortraitTokenService.generateContentPortrait(this.userId, this.playerDetails).subscribe((res: ContentPortraitResponse) => {
        if (res.content_image_base64) {
          this.refreshPlanDetails();
          const modalRef = this.modalService.open(ContentImageUploadModalComponent, { size: 'lg', backdrop: 'static', centered: true });
          modalRef.componentInstance.selectedImage = res.content_image_base64;
          modalRef.componentInstance.aiGenerateModal = true;
          modalRef.result.then((result) => {
            if (result.aiImageCancel) {
              this.refresh();
            } else {
              this.activeModal.close(result);
            }
          
          this.cdr.detectChanges();});
        }
        this.isGenerating = false;
      
          this.cdr.detectChanges();}, (error) => {
        this.isGenerating = false;
        this.activeModal.close();
        this.modalService.open(AiFailureComponent, { size: 'md', centered: true, backdrop: 'static' });
      
          this.cdr.detectChanges();});
    } else {
      this.aiPortraitTokenService.generateToken(characterRequest).subscribe((res: AIImageResponse) => {
        if (res.grok_image_base64) {
          this.refreshPlanDetails()
          this.openImageUploadModal(res.grok_image_base64)
        }
        this.isGenerating = false;
      
          this.cdr.detectChanges();}, (error) => {
        this.isGenerating = false;
        this.activeModal.close();
        this.modalService.open(AiFailureComponent, { size: 'md', centered: true, backdrop: 'static' });
      
          this.cdr.detectChanges();});
    }


  }

  openTokenRestockModal() {
    this.activeModal.close();
    this.modalService.open(AiTokenRestockComponent, { size: 'md', centered: true, backdrop: 'static' });
  }

  refreshPlanDetails() {
    this.subscriptionService.getSubscriptionByIdForUsage(this.userId).subscribe((res) => {
      if (res) {
        sessionStorage.setItem('planUsage', JSON.stringify(res));
        this.currentUserService.setPlanUsageData(res);
      }
    
          this.cdr.detectChanges();});
  }

  openModal() {
    const modalRef = this.modalService.open(AIPotraitPromptComponent, { size: 'lg', backdrop: 'static', centered: true });
    modalRef.result.then((result) => {
      this.activeModal.close()
    
          this.cdr.detectChanges();})
  }
  closeModal() {
    if (this.uploadedimage?.cropped_image && this.isFirst)
      this.activeModal.close(this.uploadedimage)
    else
      this.activeModal.close()
  }

  openImageUploadModal(base64: string, descriptionRes?: any, backstoryRes?: any) {
    const modalRef = this.modalService.open(CommonCharacterImageUploadModalComponent, { size: 'lg', backdrop: 'static', centered: true });
    modalRef.componentInstance.selectedImage = base64;
    modalRef.componentInstance.isFirst = this.isFirst;
    modalRef.componentInstance.char_id = this.char_id;
    modalRef.componentInstance.aiGenerateModal = true;
    modalRef.result.then((result) => {
      if (result.aiImageCancel) {
        this.refresh()
      }
      else {
        if (descriptionRes || backstoryRes) {
          this.activeModal.close({
            ...result,
            ...descriptionRes,
            ...backstoryRes
          });
        } else {
          this.activeModal.close(result);
        }
      }
    
          this.cdr.detectChanges();})
  }

  refresh() {
    this.getTokenBalance()
    // in future i will use this to refresh the image
  }
}
